/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-multi-assign */
/* eslint-disable react/jsx-no-bind */
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { ConfigProvider as AntdConfigProvider } from 'antd'
import enUS from 'antd/lib/locale/en_US'
import zhCN from 'antd/lib/locale/zh_CN'
import 'dayjs/locale/zh-cn'
import loadable from '@loadable/component'
import ScrollToTop from '@console/components/ScrollToTop'
import { CHANGE_LANGUAGE, COUNTRIES_AREAS, INITIAL_USER_INFO } from '@console/store/actionTypes/homepage'
import useCountryCode from '@/hooks/basic-sdk/useCountryCode'
import useLoginRedirectErrorHandler from '@/hooks/huami-login/useLoginRedirectErrorHandler'
import { immutableSelector } from '@/utils/index'
import { getLang } from './utils'

const LoadableAdmin = loadable(() => import('@console/pages/Admin'))
const LoadableRegister = loadable(() => import('@console/pages/User/Register'))
const LoadableContact = loadable(() => import('@console/pages/User/Contact'))

// 初始化 sentry(108: 产线)
const isPro = process.env.NODE_ENV === 'production'
const defaultCode = 7
const env = isPro ? 'pro' : 'testing'
const sentryConfig = new window.ApiConfig({
  env,
  defaultCode,
  sentry: {
    pro: {
      // 中国产线
      id: 'b667cd98b8004fa9a5e6567b3c302cab',
      path: '108'
    },
    testing: {
      // 测试环境
      id: '416aef6dd4014d01b13ee18bd13a8733',
      path: '109'
    },
    us: {
      // 产线 us 暂时没有
      id: '',
      path: ''
    },
    in: {
      // 产线 in 暂时没有
      id: '',
      path: ''
    },
    de: {
      // 产线 de 暂时没有
      id: '',
      path: ''
    },
    ru: {
      // 产线 ru 暂时没有
      id: '',
      path: ''
    },
    sg: {
      // 产线 sg 暂时没有
      id: '',
      path: ''
    }
  }
})
sentryConfig.sentryInstall()

export default function App() {
  const match = useRouteMatch()
  const i18n = useSelector((state: any) => {
    const { i18n } = immutableSelector(state)
    return i18n
  })
  const dispatch = useDispatch()

  useLoginRedirectErrorHandler()

  const { areas, countries, recommendCountry } = useCountryCode()

  useEffect(() => {
    dispatch({ type: CHANGE_LANGUAGE, payload: getLang() })
    dispatch({ type: INITIAL_USER_INFO })
    dispatch({
      type: COUNTRIES_AREAS,
      payload: {
        areas,
        countries,
        recommendCountry
      }
    })
  }, [dispatch, areas, countries, recommendCountry])

  // 多语言加载下来后再加载页面
  const { platform } = i18n
  if (!platform || JSON.stringify(platform) === '{}') return null
  const currentLanguage = i18n?.currentLanguage || 'zh'

  return (
    <AntdConfigProvider locale={currentLanguage === 'en' ? enUS : zhCN}>
      <ScrollToTop>
        <Switch>
          <Route path={`${match.path}user/register`} component={LoadableRegister} />
          <Route path={`${match.path}user/contact`} component={LoadableContact} />
          <Route path={`${match.path}`} component={LoadableAdmin} />
        </Switch>
      </ScrollToTop>
    </AntdConfigProvider>
  )
}
